import { render } from "./navmenu.vue?vue&type=template&id=ef2b31d0&scoped=true"
import script from "./navmenu.vue?vue&type=script&lang=js"
export * from "./navmenu.vue?vue&type=script&lang=js"

import "./navmenu.vue?vue&type=style&index=0&id=ef2b31d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2b31d0"]])

export default __exports__